












import { Component, Vue } from 'vue-property-decorator'
import { SchoolController } from './services/request.service'

@Component
export default class App extends Vue {
  private created(): void {
    if (process.env.VUE_APP_ENV !== 'PRODUCTION') {
      console.log('current environment is ' + process.env.VUE_APP_ENV)
    }
    SchoolController.getUrlUniqueSchools()
      .then(res => {
        const { logo, logoSmall: smallLogo } =
          res.data.filter(item => item.url === window.origin)[0] || {}
        this.$store.commit('setLogo', { logo, smallLogo })
      })
      .catch(err => {
        console.error(err)
      })
  }
}
